module.exports = __webpack_public_path__ + "img/background.e363f88f.png";